import { OnboardingOptions } from '@/domain/usecases/onboarding/onboarding-options'
import { OnboardingSkillsRecommended } from '@/domain/usecases/onboarding/onboarding-skills-recommended'
import { importRemote } from '@/main/routes/helpers/loaders'
import { queryClient } from '@/infra/http'

/**
 * Loads onboarding step 4 data
 * Fetches both step 4 options and recommended skills by areas
 */
export async function loadOnboardingStep4() {
  const [remoteOnboardingOptions, remoteOnboardingSkillsRecommended] = await Promise.all([
    importRemote<OnboardingOptions>('makeRemoteOnboardingOptions', queryClient),
    importRemote<OnboardingSkillsRecommended>('makeRemoteOnboardingSkillsRecommended', queryClient)
  ])

  const [step4Options, skillsRecommendedByAreas] = await Promise.all([
    remoteOnboardingOptions.getStep4(),
    remoteOnboardingSkillsRecommended.getStepRecommendSkillByAreas()
  ])

  return {
    ...step4Options,
    skillsRecommendedByAreas
  }
}
